/*
 * ChatToastNotifier — DISABLED (Fix 56, Feb 2026).
 *
 * Sebelumnya: poll `/api/chats/all` tiap 30s → toast Sonner untuk pesan baru.
 * Sekarang: no-op. User memilih notifikasi via Telegram saja.
 *
 * Yang masih hidup di sistem:
 *   - Notif via Telegram (backend push_service + notification_dispatcher).
 *   - Badge counter di navbar bells (Marketing/Gudang/Nakes) — endpoint
 *     `/api/notifications` terpisah, tidak lewat komponen ini.
 *   - AnnouncementPopup untuk pengumuman global (bukan notif event-based).
 *
 * File dipertahankan sebagai stub supaya App.js tidak perlu diubah + tetap
 * ada anchor kalau di masa depan mau re-enable in-app toast.
 */
export default function ChatToastNotifier() {
  return null;
}
